
import SearchNormal from "../../../assets/duotone/SearchNormal.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SearchNormalIcon({ className, dataTestid = "SearchNormalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SearchNormal data-testid={dataTestid} className={classes} {...rest} />
  );
}
